import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Menu } from 'antd';
import { NAV_HOME, NAV_NDES, NAV_NDES_CREATE, NAV_RELATIVE_NDES_BASIC_DETAILS, NAV_STATISTICS, NAV_BLOG } from '../../../constants';
import { Chart, Document, Edit, Home, Plus } from 'react-iconly';
import { IoIosPulse } from 'react-icons/io';

const NavLink = ({ to, children, onClose }) => (
  <Link to={to} onClick={onClose} style={{ color: 'inherit' }}>{children}</Link>
);

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired
};

const HeaderNav = ({
  onClose = () => {},
  mode = 'horizontal'
}) => {
  const nav2 = [
    {
      key: 'home',
      label: <NavLink to={NAV_HOME} onClose={onClose}>Home</NavLink>,
      icon: <Home />
    },
    {
      key: 'ndes',
      label: 'NDEs',
      icon: <IoIosPulse />,
      children: [
        {
          label: <NavLink to={NAV_NDES_CREATE + NAV_RELATIVE_NDES_BASIC_DETAILS} onClose={onClose}>Submit your NDE</NavLink>,
          key: 'ndes-new',
          icon: <Plus set="curved" />
        },
        {
          label: <NavLink to={NAV_NDES} onClose={onClose}>View all NDEs</NavLink>,
          key: 'ndes-all',
          icon: <Document set="light" />
        }
      ]
    },
    {
      key: 'statistics',
      label: <NavLink to={NAV_STATISTICS} onClose={onClose}>Stats</NavLink>,
      icon: <Chart />
    },
    {
      key: 'blog',
      label: <NavLink to={NAV_BLOG} onClose={onClose}>Blog</NavLink>,
      icon: <Edit />
    }
  ];

  return (
    <Menu
      mode={mode}
      items={nav2}
    />
  );
};

HeaderNav.propTypes = {
  onClose: PropTypes.func,
  mode: PropTypes.oneOf(['horizontal', 'inline'])
};

export default HeaderNav;
